import { render, staticRenderFns } from "./GamificationBanner.vue?vue&type=template&id=69ef643e&scoped=true"
import script from "./GamificationBanner.vue?vue&type=script&lang=js"
export * from "./GamificationBanner.vue?vue&type=script&lang=js"
import style0 from "./GamificationBanner.vue?vue&type=style&index=0&id=69ef643e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ef643e",
  null
  
)

export default component.exports